export default "__VITE_ASSET__BeVhZpTF__"